<template>
  <div class="yx-handle-required-page main-layout">
    <el-card class="box-form box-inner">
      <c-title slot="header" title="个人资料" :back="false"></c-title>
      <personal-info :id="studentId"></personal-info>
    </el-card>
  </div>
</template>

<script>
import PersonalInfo from "./personalInfo";
export default {
  components: {
    PersonalInfo,
  },
  data() {
    return {
      currentTab: "first",
      title: "",
      studentId:''
    };
  },
  created(){
    this.studentId = JSON.parse(localStorage.getItem('userInfo')).id;
  },
  mounted() {

  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>


